import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import Add from "../../assets/Add";
import Edit from "../../assets/Edit";
import Delete from "../../assets/Delete";
import View from "../../assets/View";
import columns from "../../columns/invoice/column";
import SkeletonTable from "../../components/table/SkeletonTable";
import {
  GetInvoiceTemplateListApi,
  DeleteInvoiceTemplateApi,
} from "../../api/request/invoice";
import TemplateForm from "./components/TemplateForm";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import ViewInvoice from "./components/ViewInvoice";

const Invoice = () => {
  const [templateList, setTemplateList] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("view");
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isViewInvoiceModalOpen, setIsViewInvoiceModalOpen] = useState(false);

  const getTemplateList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetInvoiceTemplateListApi();
      if (data?.status) {
        setTemplateList(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <div
                  className={`${
                    item?.status == "active" ? "text-green-500" : "text-red-500"
                  } font-semibold uppercase`}
                >
                  {item?.status}
                </div>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              action: (
                <div className="flex items-center gap-5">
                  <button
                    onClick={() => {
                      setSelectedTemplate(item);
                      setMode("edit");
                    }}
                  >
                    <Edit />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedTemplate(item);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <Delete />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedTemplate(item);
                      setIsViewInvoiceModalOpen(true);
                    }}
                  >
                    <View />
                  </button>
                </div>
              ),
            };
          })
        );
      }
      setTotal(data?.total_record);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTemplateList();
  }, []);

  const deleteInvoice = async () => {
    try {
      setIsDeleteLoading(true);
      const { data } = await DeleteInvoiceTemplateApi({
        invoice_temp_id: selectedTemplate?.id,
      });
      if (data.status) {
        setIsDeleteLoading(false);
        setIsDeleteModalOpen(false);
        toast.success(data.message);
        setSelectedTemplate({});
        getTemplateList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsDeleteLoading(false);
    }
  };

  return (
    <div>
      <div className="border rounded-lg bg-White pb-5">
        {mode === "view" && (
          <>
            <div className="flex items-center justify-between p-5">
              <p className="font-semibold text-xl">
                Invoice Templates {total ? `(${total})` : null}
              </p>
              <div className="flex gap-2 items-center">
                <button
                  className="bg-secondary text-White flex items-center gap-2 rounded-lg py-2 px-4"
                  onClick={() => {
                    setSelectedTemplate({});
                    setMode("add");
                  }}
                >
                  <Add />
                  <span>Add Template</span>
                </button>
              </div>
            </div>

            <SkeletonTable
              columns={columns}
              searchingFields={["name", "amount"]}
              data={templateList}
              isLoading={isLoading}
            />
          </>
        )}

        {["add", "edit"].includes(mode) && (
          <TemplateForm
            mode={mode}
            setMode={setMode}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            getTemplateList={getTemplateList}
          />
        )}
      </div>

      {/* --- Delete confirmation modal --- */}
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        message={`Are you sure you want to delete this invoive template?`}
        onConfirm={deleteInvoice}
        isLoading={isDeleteLoading}
        loadingLabel={`Deleting invoice...`}
      />

      <ViewInvoice
        setIsOpen={setIsViewInvoiceModalOpen}
        isOpen={isViewInvoiceModalOpen}
        selectedTemplate={selectedTemplate}
      />
    </div>
  );
};

export default Invoice;
